<template>
    <div>
        <template v-if="asientos.length != 0">
            <label>{{ $t('nuevo_abono.tus_asientos') }}</label>
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                <div v-for="(asiento, index) in asientos" class="lightgray-content p-2 mb-2 rounded-pill" :key="index">
                    <div class="text-bold mb-2 d-md-flex">
                        <div class="oswald">
                            {{ $t('general.abono', {abono: teatro.texto_abono}) }} {{ ++index }}.
                            <span v-if="asiento.asiento && asiento.asiento.zona_nombre">{{ asiento.asiento.zona_nombre }}</span>
                        </div>
                        <div class="ml-2" v-if="asiento.asiento && typeof asiento.asiento === 'object'">
                            <small v-if="asiento.asiento.fila">{{ $t('general.fila') }}: {{ asiento.asiento.fila }} /</small>
                            <small v-if="asiento.asiento.asiento">{{ $t('general.butaca') }}: {{ asiento.asiento.asiento }}</small>
                            <small v-if="asiento.asiento.visibilidad_reducida" class="text-danger">
                                - {{ $t('visibilidad_reducida.nombre') }}
                            </small>
                            <small v-if="asiento.asiento.porcentaje_visibilidad" class="text-danger">
                                : {{ asiento.porcentaje_visibilidad }}%
                            </small>
                        </div>
                    </div>
                </div>
                <div v-if="AsientosValidos == undefined  || AsientosValidos">
                    <Button
                        v-if="configuracion_valida && can_click"
                        type="submit"
                        :label="$t('nuevo_abono.continuar_compra')"
                        custom-class="mb-4 mt-4 mb-lg-5 mt-lg-2"
                        @click="continuar"
                    />
                </div>
                <h3 v-else>No puedes dejar un hueco entre dos asientos</h3>


                <div v-if="!configuracion_valida" class="alert alert-warning">
                    {{ $t('nuevo_abono.no_huecos') }}
                </div>
            </ValidationObserver>
        </template>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import store from '@/store';
    import Button from '@/modules/ui/Button.vue';

    const props = defineProps({
        asientos: {
            type: Array,
            required: true
        },
        configuracion_valida: {
            type: Boolean,
            required: true
        },
        can_click: {
            type: Boolean,
            required: true
        },
        AsientosValidos: {
            type: Boolean,
            default: undefined
        }
    });

    const emit = defineEmits(['continuar']);

    const teatro = computed(() => store.getters.getTeatro);

    const continuar = () => {
        emit('continuar', props.asientos);
    };
</script>
